import { render, staticRenderFns } from "./iconLaurels.vue?vue&type=template&id=d1c810e6&scoped=true&"
import script from "./iconLaurels.vue?vue&type=script&lang=js&"
export * from "./iconLaurels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c810e6",
  null
  
)

export default component.exports